<template>
  <div id="app">
    <IndexPage/>
  </div>
</template>

<script>
import IndexPage from "./view/index"
export default {
  name: 'App',
  components:{
    IndexPage
  },

}
</script>

<style>
  html,body,#app{
    width: 100%;
    height: 100%;
    margin:0;
    padding:0;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue